"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbHybridSessionV2 = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const framework_1 = require("../../../../framework");
const events_1 = require("../../../../features/events");
const timeOut_helper_1 = require("../../../../features/timeOut/helpers/timeOut.helper");
__exportStar(require("./types"), exports);
class MbHybridSessionV2 extends framework_1.BaseSession {
    constructor(sessionStorage, refreshToken, eventBus) {
        super(sessionStorage);
        this.parseRefreshToken = (data) => {
            const parseData = JSON.parse(data);
            const decode = web_ui_framework_1.AdvanceDecode.object({
                accessToken: web_ui_framework_1.AdvanceDecode.field('access_token', web_ui_framework_1.BasicDecode.string),
                expiresIn: web_ui_framework_1.AdvanceDecode.field('expires_in', web_ui_framework_1.BasicDecode.int),
            });
            return decode(parseData);
        };
        this.doRefresh = () => __awaiter(this, void 0, void 0, function* () {
            try {
                (0, events_1.publishRefreshingSessionEvent)(undefined, this.eventBus);
                const data = yield this.refreshToken();
                const { accessToken, expiresIn } = this.parseRefreshToken(data);
                const newSessionData = {
                    accessToken,
                    expiresIn,
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(expiresIn),
                };
                (0, events_1.publishRefreshedSessionEvent)(newSessionData, this.eventBus);
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e, this.eventBus);
                throw e;
            }
        });
        this.isDataValid = (sessionData) => {
            if (sessionData.accessToken) {
                return true;
            }
            return false;
        };
        this.refreshToken = refreshToken;
        this.eventBus = eventBus;
    }
    onRefreshToken(callback) {
        return (0, events_1.subscribeRefreshedSessionEvent)(callback, this.eventBus);
    }
    onRefreshTokenError(callback) {
        return (0, events_1.subscribeErrorRefreshingSessionEvent)(callback, this.eventBus);
    }
    onRefreshingToken(callback) {
        return (0, events_1.subscribeRefreshingSessionEvent)(callback, this.eventBus);
    }
}
exports.MbHybridSessionV2 = MbHybridSessionV2;
//# sourceMappingURL=index.js.map